module.exports = __webpack_public_path__ + "static/media/ic-saber-mais.b3f2bc0f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ResultItem/images/ic-saber-mais.svg
// module id = 1070
// module chunks = 0